/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// Loaded before CoreUI app.js
import './bootstrap';
import '@fortawesome/fontawesome-free/js/all.min';
import 'pace';
import './plugins';

import Vue from 'vue';
window.Vue = Vue;

const token = document.head.querySelector('meta[name="auth-token"]');

if (token) {
    window.axios.defaults.headers.common['X-AUTH-TOKEN'] = token.content;
    console.log('Auth Token ' + token.content + ' appended.')
} else {
    console.error('Auth token not found');
}


// Form Builder
Vue.component('form-builder', require('./components/FormBuilderComponent').default);

// Agenda
Vue.component('agenda-calendar-view', require('./components/Agenda/AgendaCalendarView').default);

const app = new Vue({
    el: '#app'
});

